import './BtnWithModal.scss';
import BtnWithModal from './BtnWithModal';

export default BtnWithModal;